module.exports = __webpack_public_path__ + "static/media/blue-check-icon.2039a189.svg";